export const getSkeletonWidth = (from: number, to: number): number =>
  Math.floor(Math.random() * (to - from + 1)) + from;
